'use client';

import { VtmnToast } from '@vtmn/react';
import { useTranslations } from 'next-intl';

export const Toaster = () => {
  const t = useTranslations('PROFILE.GLOBAL');

  return (
    <VtmnToast
      content={t('TOASTER')}
      withIcon
    />
  );
};
